import { useContext } from 'react';
import { AdminCreditUsageContext } from '@features/admin-credit-usage/contexts/AdminCreditUsageContext';
import { AdminCreditUsageContextValues } from '@features/admin-credit-usage/types';

const useAdminCreditUsageFilters = (): AdminCreditUsageContextValues => {
  const context = useContext(AdminCreditUsageContext);

  if (!context) {
    throw new Error(
      'useAdminCreditUsageFilters must be used within a AdminCreditUsageProvider'
    );
  }

  return context;
};

export default useAdminCreditUsageFilters;
